// ═══════════════════════════════════════════════════════════════════════════════
// Inline alert when receipt total does not match line-item sum
// ═══════════════════════════════════════════════════════════════════════════════

type ReceiptTotalMismatchBannerProps = {
  message: string;
};

export const ReceiptTotalMismatchBanner = ({ message }: ReceiptTotalMismatchBannerProps) => (
  <div
    className="mt-2 flex items-center gap-2 rounded-xl bg-red-50 px-4 py-3 text-red-700 dark:bg-red-950/40 dark:text-red-100"
    role="alert"
    aria-live="polite"
  >
    <svg className="h-5 w-5 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden>
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
      />
    </svg>
    <span className="text-sm font-medium">{message}</span>
  </div>
);
